import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRouteEnum } from '../../routes/routeEnums';

// Import menu icons
import assetsActive from '../../assets/images/bottom-menu/assets-active.svg';
import assets from '../../assets/images/bottom-menu/assets.svg';
import orderActive from '../../assets/images/bottom-menu/order-active.svg';
import order from '../../assets/images/bottom-menu/order.svg';
import historyActive from '../../assets/images/bottom-menu/history-active.svg';
import history from '../../assets/images/bottom-menu/history.svg';
import menuActive from '../../assets/images/bottom-menu/menu-active.svg';
import menu from '../../assets/images/bottom-menu/menu.svg';
import statementActive from '../../assets/images/bottom-menu/statement-active.svg';
import statement from '../../assets/images/bottom-menu/statement.svg';

interface MenuItem {
  icon: string;
  activeIcon: string;
  label: string;
  path: AppRouteEnum;
}

const menuItems: MenuItem[] = [
  {
    icon: assets,
    activeIcon: assetsActive,
    label: 'Tài sản',
    path: AppRouteEnum.ASSETS,
  },
  {
    icon: statement,
    activeIcon: statementActive,
    label: 'Sao kê',
    path: AppRouteEnum.STATEMENT,
  },
  {
    icon: order,
    activeIcon: orderActive,
    label: 'Đặt lệnh',
    path: AppRouteEnum.ORDER,
  },
  {
    icon: history,
    activeIcon: historyActive,
    label: 'Sổ lệnh',
    path: AppRouteEnum.HISTORY,
  },
  {
    icon: menu,
    activeIcon: menuActive,
    label: 'Menu',
    path: AppRouteEnum.MENU,
  },
];

const ACTIVE_TAB_KEY = 'vftrade-active-tab';

const BottomMenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Helper function to determine if a path is active
  const isPathActive = (path: AppRouteEnum): boolean => {
    // Check if current path starts with the tab's base path
    // This handles nested routes like /assets/some-sub-route
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  // Store active tab when navigating
  const handleNavigate = (path: AppRouteEnum) => {
    // Save the active tab to localStorage
    localStorage.setItem(ACTIVE_TAB_KEY, path);
    
    if (!isPathActive(path)) {
      // Clear history and navigate to new path
      window.history.replaceState(null, '', path);
      navigate(path, { replace: true });
    }
  };

  return (
    <div className="bg-white border-t border-[#E7ECF3] h-[80px] flex items-center justify-between px-6 text-[11px] pb-4 w-full">
      {menuItems.map((item) => {
        // Check if this tab is currently active
        // First check URL path, then fall back to stored value after reload
        const isActive = isPathActive(item.path) || 
          (!menuItems.some(mi => isPathActive(mi.path)) && localStorage.getItem(ACTIVE_TAB_KEY) === item.path);
        return (
          <button
            key={item.path}
            onClick={() => handleNavigate(item.path)}
            className="flex flex-col items-center gap-1"
          >
            <img
              src={isActive ? item.activeIcon : item.icon}
              alt={item.label}
              className="w-6 h-6"
            />
            <span
              className={`text-xs ${
                isActive ? 'text-[#5A4099]' : 'text-[#808191]'
              }`}
            >
              {item.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default BottomMenu;
